import { render } from "./Login.vue?vue&type=template&id=0506f59c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0506f59c"

export default script